import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MetavendedorComponent } from './components/metavendedor/metavendedor.component';

const routes: Routes = [
  { path: 'metavendedor', component: MetavendedorComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MetavendedorRoutingModule { }
